import React, { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, Button, Alert } from 'react-bootstrap';
// import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { ContentsPropTypes } from './ContentPropTypes';
// import validationErrors from '../../../util/validationErrors';
import { ImageOnHeadContent } from '../../common/models/ArPackage';
import SingleFileUpload from '../../../components/SingleFileUpload';
import {
  selectUploadedFileId,
  setUploadedFileId,
  uploadFile,
} from '../arPackageSlice';
import { getAppDownloadUrl } from '../../../util';

export default function ImageOnHeadComponent({
  packageId,
  content,
  onSubmitContent,
  onCancel,
}: ContentsPropTypes) {
  const c = content as ImageOnHeadContent;

  // boilerplate
  const dispatch = useDispatch();

  // state
  const uploadedFileId = useSelector(selectUploadedFileId);

  // formik
  const formik = useFormik({
    validationSchema: Yup.object().shape({
      image_on_head_url: Yup.string().required('画像データが未設定です'),
    }),
    initialValues: {
      image_on_head_url: c.image.image_url,
    },
    onSubmit: (val) => {
      const newContent: ImageOnHeadContent = {
        ...c,
        image: {
          image_url: val.image_on_head_url,
        },
      };
      onSubmitContent(newContent);
    },
    enableReinitialize: true,
  });

  // callbacks
  const onUploadClicked = async (file: File) => {
    await dispatch(uploadFile(packageId, file));
  };

  useEffect(() => {
    if (uploadedFileId) {
      formik.setFieldValue(
        'image_on_head_url',
        getAppDownloadUrl(packageId, uploadedFileId)
      );
      dispatch(setUploadedFileId());
    }
  }, [uploadedFileId]);

  return (
    <FormikProvider value={formik}>
      <Form noValidate onSubmit={formik.handleSubmit}>
        <div className="ms-2 mb-2">
          拡張子 .jpg, .png
          のファイルのみ許可されています。ファイルサイズは200MBまでです。
        </div>
        <SingleFileUpload
          title="静止画"
          noUploadText="未設定"
          uploadedText="設定済み"
          showIcon
          isUploaded={!!formik.values.image_on_head_url}
          onUpload={onUploadClicked}
          allowedMimeTypes={['image/jpeg', 'image/png']}
        />

        <Alert variant="danger" show={!!formik.errors.image_on_head_url}>
          {formik.errors.image_on_head_url}
        </Alert>

        <div className="mt-5">
          <Button type="submit" variant="primary" className="me-2">
            保存
          </Button>
          <Button type="button" variant="secondary" onClick={onCancel}>
            キャンセル
          </Button>
        </div>
      </Form>
    </FormikProvider>
  );
}
